/* global define, window */

define('views/SearchControlsView',[
    'jquery',
    'underscore',
    'backbone',
    'text!templates/views/SearchControls.html'
], function($, _, Backbone, template) {

    'use strict';

    var View = Backbone.View.extend({
        events: {
            'click .btn-restart': 'onRestart',
            'click .btn-save': 'onSave',
            'click .btn-search': 'onSearch'
        },
        initialize: function() {

        },
        render: function() {
            this.$el.html(template);
            this.$el.hide();
            return this;
        },
        onRestart: function() {

            if (window.parent) {
                var $top = $(window.parent.document);
                $top.find('[name=startOverButton]').click();
            }
        },
        onSave: function() {

            if (window.parent) {
                var $top = $(window.parent.document);
                $top.find('#saveSearchButton').click();
            }

        },
        onSearch: function() {

            if (window.parent) {
                var $top = $(window.parent.document);
                $top.find('#finishSearchButton').click();
            }
        }
    });

    return View;
});

